import { FC, useEffect } from 'react';
import styled from './index.module.scss';
import Banner from '@/components/XPower/components/Banner';
import Safety from '@/components/XPower/components/Safety';
import Performance from '@/components/XPower/components/Performance';
import XStream from '@/components/XPower/components/XStream';
import XBoost from '@/components/XPower/components/XBoost';
import XLink from '@/components/XPower/components/XLink';
import XCooling from '@/components/XPower/components/XCooling';
import XFusion from '@/components/XPower/components/XFusion';
import XGuard from '@/components/XPower/components/XGuard';
import ProductList from '@/components/XPower/components/ProductList';
import Scollbar from '@/components/XPower/elements/Scollbar';
import EfScrollAni from '@/efscrollani';
import { EU_LIST } from '@/components/XPower/constants';
import getLocal from '@/app/utils/getLocal';

const XPowerCompoment: FC = ({}) => {
    const { locale } = getLocal();
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                    .glo-editor-modal-show {
                        z-index: 2103;
                    }
                    body::-webkit-scrollbar {
                        width: 6px;
                    }
                    body::-webkit-scrollbar-track {
                        background-color: #000;
                    }
                    body::-webkit-scrollbar-thumb {
                        border-radius: 3px;
                        background: #808080;
                    }
                `}
            </style>
            <div className={`${styled.XPowerCompoment}`}>
                <Scollbar mobile />
                <Banner />
                <Safety />
                <div id="scoll-central">
                    <Scollbar />
                    <Performance />
                    <XStream />
                    <XBoost />
                    {!EU_LIST.includes(locale) && <XLink />}
                    <XCooling />
                    <XFusion />
                    <XGuard />
                    <ProductList />
                </div>
            </div>
        </>
    );
};

export default XPowerCompoment;
